
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "commitHash": "adc0f8c31492e8eb2f03b06ac36ba053e8ba6224",
    "version": "16.2.0"
};
